<template>
  <div>.. Login in progress ..</div>
</template>


<script>
import {mapActions} from "vuex";
export default {
  name: 'AutoLogin',
  async mounted() {
    this.loading = true
    if (this.$route.query.jwt) {
      this.loginWithJwt(this.$route.query.jwt)
      await this.getCurrentUser()
    }

    const redirect = this.$route.query.redirect
    if (redirect === 'checkins') {
      sessionStorage.setItem('picacode', this.$route.query.picacode)
      await this.$router.push({name: 'checkins-list', query: {picacode: this.$route.query.picacode}})

    }
    else
      await this.$router.push({name: 'homepage'})
  },
  methods: {
    ...mapActions('auth', [
      'loginWithJwt',
      'getCurrentUser'
    ]),
  }
}
</script>
